import { Button, Link } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var ActionButton = function ActionButton(_ref) {
  var _ref$button = _ref.button,
    text = _ref$button.text,
    link = _ref$button.link,
    mobLink = _ref$button.mobLink,
    variant = _ref$button.variant,
    rightSideNode = _ref$button.rightSideNode,
    onClick = _ref$button.onClick,
    disabled = _ref$button.disabled,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('action_button'),
    "data-t-id": "TeaserBanner-ActionButton"
  }, link && /*#__PURE__*/React.createElement(Link, {
    buttonSize: "l",
    buttonVariant: variant || 'main',
    href: isMobile && mobLink ? mobLink : link,
    isFullWidth: true,
    onClick: onClick,
    size: "size5-m",
    variant: "button"
  }, text), onClick && !link && /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    fullWidth: true,
    onClick: onClick,
    rightSideNode: rightSideNode,
    size: "l",
    variant: variant || 'main'
  }, text));
};
export { ActionButton };